<template>
  <!-- DealerPurchasePanel — Panel 2: 딜러 매입 - REQ-FE-TRC-003~005 -->
  <!-- SPEC-CHINA-LOT-FLOW-DASHBOARD-001 REQ-FE-DETAIL-006: 확장 필드 추가 (voucherCode/unitPrice/productManufacturer/purchaseOrderCode) -->
  <a-card class="lot-trace-panel" :loading="loading">
    <template #title>
      <span>{{ $t('lotTrace_panel_dealerPurchase') }}</span>
      <a-badge
        :count="panelData.count"
        :overflow-count="999"
        :style="{ marginLeft: '8px', backgroundColor: panelData.count > 0 ? '#52c41a' : '#d9d9d9' }"
      />
      <span v-if="panelData.truncated" style="font-size: 12px; color: #faad14; margin-left: 8px;">
        {{ $t('lotTrace_truncated') }}
        ({{ $t('dealerGsp_total_count', { count: panelData.preCapTotal }) }})
      </span>
    </template>
    <template #extra>
      <a-button v-if="value" type="link" size="small" @click="viewAll">{{ $t('lotTrace_actions_viewAll') }}</a-button>
    </template>

    <template v-if="loading">
      <a-skeleton active :paragraph="{ rows: 3 }" />
    </template>
    <template v-else-if="panelData.count === 0">
      <a-empty :description="emptyMessage" />
    </template>
    <template v-else>
      <div style="overflow-x: auto;">
        <a-table
          :data-source="panelData.rows"
          :columns="columns"
          :pagination="false"
          row-key="_id"
          size="small"
          :scroll="{ x: 1100 }"
        >
          <template #bodyCell="{ column, record }">
            <template v-if="column.key === 'batchNumber'">
              <a-button
                type="link"
                size="small"
                style="padding: 0; min-height: 44px; height: auto;"
                @click="deepLinkToSource(record.batchNumber)"
              >{{ record.batchNumber || '-' }}</a-button>
            </template>
            <template v-else-if="column.key === 'warehousingDate'">
              {{ formatDate(record.warehousingDate) }}
            </template>
            <!-- REQ-FE-DETAIL-006: 확장 필드 -->
            <template v-else-if="column.key === 'voucherCode'">
              <span class="code-mono">{{ record.voucherCode || '-' }}</span>
            </template>
            <template v-else-if="column.key === 'unitPrice'">
              {{ record.unitPrice != null ? record.unitPrice.toLocaleString() : '-' }}
            </template>
          </template>
        </a-table>
      </div>
    </template>
  </a-card>
</template>

<script>
export default {
  name: 'DealerPurchasePanel',
  props: {
    panelData: { type: Object, default: () => ({ count: 0, preCapTotal: 0, truncated: false, rows: [] }) },
    loading: { type: Boolean, default: false },
    value: { type: String, default: '' },
    anomalies: { type: Array, default: () => [] },
  },
  emits: ['navigate'],
  computed: {
    columns() {
      return [
        { title: this.$t('lotTrace_col_batchNumber'), dataIndex: 'batchNumber', key: 'batchNumber', width: 170 },
        { title: this.$t('lotTrace_col_warehousingDate'), dataIndex: 'warehousingDate', key: 'warehousingDate', width: 130 },
        { title: this.$t('lotTrace_col_productCode'), dataIndex: 'productCode', key: 'productCode', width: 130 },
        { title: this.$t('lotTrace_col_supplierName'), dataIndex: 'supplierName', key: 'supplierName', width: 160, ellipsis: true },
        { title: this.$t('lotTrace_col_quantity'), dataIndex: 'quantity', key: 'quantity', width: 80, align: 'right' },
        // 확장 필드
        { title: this.$t('lotFlow_detail_field_voucherCode'), dataIndex: 'voucherCode', key: 'voucherCode', width: 150 },
        { title: this.$t('lotFlow_detail_field_unitPrice'), dataIndex: 'unitPrice', key: 'unitPrice', width: 100, align: 'right' },
        { title: this.$t('lotFlow_detail_field_productManufacturer'), dataIndex: 'productManufacturer', key: 'productManufacturer', width: 160, ellipsis: true },
        { title: this.$t('lotFlow_detail_field_purchaseOrderCode'), dataIndex: 'purchaseOrderCode', key: 'purchaseOrderCode', width: 150 },
      ];
    },
    emptyMessage() {
      const match = (this.anomalies || []).find((a) =>
        ['not_found', 'missing_dealer_purchase'].includes(a.type)
      );
      if (match) {
        if (match.type === 'missing_dealer_purchase') {
          return this.$t(
            match.severity === 'info'
              ? 'lotTrace_anomaly_missing_dealer_purchase_info'
              : 'lotTrace_anomaly_missing_dealer_purchase_warning'
          );
        }
        return this.$t('lotTrace_anomaly_not_found');
      }
      return this.$t('lotTrace_emptyState');
    },
  },
  methods: {
    formatDate(val) {
      if (!val) return '-';
      const d = new Date(val);
      if (isNaN(d)) return val;
      return d.toLocaleDateString('zh-CN', { timeZone: 'Asia/Shanghai' });
    },
    viewAll() {
      if (!this.value) return;
      this.$emit('navigate', `/dealer-gsp/purchase-inbounds?batchNumber=${encodeURIComponent(this.value)}`);
    },
    deepLinkToSource(batchNumber) {
      if (!batchNumber) return;
      this.$emit('navigate', `/dealer-gsp/purchase-inbounds?batchNumber=${encodeURIComponent(batchNumber)}`);
    },
  },
};
</script>

<style scoped>
.code-mono {
  font-family: "SF Mono", "Cascadia Mono", Menlo, monospace;
  font-size: 12px;
}
</style>
